// extracted by mini-css-extract-plugin
module.exports = {"InfoBox":"InfoBox_InfoBox__3TPlK","textArea":"InfoBox_textArea__3i2Ei"};